module.exports = __webpack_public_path__ + "img/email.1b354a97.svg";